// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const ballista = defineModel({
  id: "ballista",
  batchId: "future",
  name: "Ballista",
  tags: ["scenery","ballista","low-poly","age-of-mcp","future","military"],
  summary: "A ballista — a giant bolt-thrower (parked: no combat system yet).",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.36, 0.04, 0.05), color: "#5c3c20", position: [0, 0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.04, 0.36), color: "#5c3c20", position: [0, 0.02, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.3, 0.07), color: "#5c3c20", position: [0, 0.16, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.04, 0.1, 8), color: "#3a3f44", position: [0, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.62, 0.06, 0.08), color: "#7a512c", position: [0.06, 0.38, 0] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.18, 8), color: "#5c3c20", position: [0.24, 0.38, 0.12] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.18, 8), color: "#5c3c20", position: [0.24, 0.38, -0.12] },
      { geometry: new THREE.BoxGeometry(0.26, 0.03, 0.03), color: "#7a512c", position: [0.34, 0.38, 0.16], rotation: [0, -0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.03, 0.03), color: "#7a512c", position: [0.34, 0.38, -0.16], rotation: [0, 0.5, 0] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.34, 4), color: "#cabf9a", position: [0.42, 0.38, 0.07], rotation: [1.570796, 0, -0.4] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.34, 4), color: "#cabf9a", position: [0.42, 0.38, -0.07], rotation: [1.570796, 0, 0.4] },
      { geometry: new THREE.CylinderGeometry(0.012, 0.012, 0.4, 5), color: "#7a512c", position: [0.18, 0.42, 0], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.ConeGeometry(0.025, 0.07, 5), color: "#9aa0a6", position: [0.4, 0.42, 0], rotation: [0, 0, -1.570796] },
    ],
  animations: [],
});
